import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { ENVIRONMENT } from '../../../../environments/environment.interface';
import { Impediment, ImpedimentGroup } from '../../../api/app-types/impediment.app';
import { IMPEDIMENT_PROVIDER } from '../../../api/services/impediment.service';
import { PaginatedResponse } from '../../pagination/paginated-response';
import { REPORT_API } from '../../../api/services/report.service';

export const impedimentResolver: ResolveFn<ImpedimentGroup[]> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(IMPEDIMENT_PROVIDER);
	const env = inject(ENVIRONMENT);
	const reportApi = inject(REPORT_API);

	const assignmentId = route.paramMap.get('assignmentId');
	const reportId = route.paramMap.get('reportId');

	if (!assignmentId || !reportId) return [];
	try {
		const report = await reportApi.getReportOfAssignment(assignmentId, Number(reportId));
		const res = await api.getPossibleImpediments(
			assignmentId,
			report.categoryReport.id,
			env.pagination.offset,
			env.pagination.range,
		);
		return res;
	} catch {
		return [];
	}
};

export const allImpedimentAsGroupsResolver: ResolveFn<ImpedimentGroup[]> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(IMPEDIMENT_PROVIDER);
	const reportApi = inject(REPORT_API);

	const assignmentId = route.paramMap.get('assignmentId');
	const reportId = route.paramMap.get('reportId');

	if (!assignmentId || !reportId) return [];
	try {
		const report = await reportApi.getReportOfAssignment(assignmentId, Number(reportId));
		const groups = await api.getAllImpediments(assignmentId, report.categoryReport.id);
		return groups;
	} catch {
		return [];
	}
};

export const impedimentsOfReportResolver: ResolveFn<PaginatedResponse<Impediment>> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(IMPEDIMENT_PROVIDER);
	const reportId = route.paramMap.get('reportId');
	if (!reportId) return { entities: [], totalEntities: 0, offset: 0, range: 0 };
	try {
		const res = await api.getImpedimentsOfReport(reportId);
		return res;
	} catch {
		return { entities: [], totalEntities: 0, offset: 0, range: 0 };
	}
};
